<template>
  <div class="home">

    <gnetHeader v-if="showheader"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="'SalesPaddy'"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>

    <qualifica v-on:cancel="showQualifica=false"></qualifica>

  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetMixLib from '@/mixin.js'
import qualifica from '../components/qualifica.vue'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    qualifica,
  },
  data: function() {
    return {
        showheader: true,
    };
  },
  created: function() {
  },
  mounted: function() {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>

